export default __webpack_public_path__ + "static/media/no_img.c7747d1b.png";